import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { New, CacheService } from "mapfre-auditlib";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
   providedIn: "root"
})
export class DaysNewsService {

   className = 'DaysNewsService'

   constructor(private http: HttpClient, private cacheService: CacheService) { }

   getAllNews(cache = true, cacheKey = "allNews"): Observable<New[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<New[]>(environment.base_URL + "/news").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   newNew(newItem) {
      return this.http.post(environment.base_URL + "/news", newItem)
   }

   updateNew(editItem, id) {
      return this.http.put(environment.base_URL + `/news/${id}`, editItem)
   }

   deleteNew(id: Number) {
      return this.http.delete(environment.base_URL + `/news/${id}`)
   }

}
